// extracted by mini-css-extract-plugin
module.exports = {"container":"e336fd7528--container--R9hGX","wrapper":"e336fd7528--wrapper--Mkh5O","title":"e336fd7528--title--jQYcA","tags":"e336fd7528--tags--knYdl"};